export type Sex = 'female' | 'male' | 'unknown';

export const SEX_DISPLAY: Record<Sex, string> = {
  female: 'Female',
  male: 'Male',
  unknown: 'Unknown',
};

export interface DenialListItem {
  id: string;
  patientName: string;
  dateOfBirth: string;
  sex: Sex;
  reason: string | null;
  dateAdded: string | null;
  createdAt: string;
  updatedAt: string;
}
